import { Link, useNavigate } from "react-router-dom";
import { PiPencilSimple, PiTrash } from "react-icons/pi";
import "./Recipe.scss";
import { useContext } from "react";
import { ToastContext } from "../../providers/Toast.provider";
import { deleteRecipe } from "../../views/recipe-editor/services/delete-recipe.service";

function Recipe({ recipe }) {
  const { createToast } = useContext(ToastContext);
  const navigate = useNavigate();

  const handleDelete = () => {
    const confirmed = window.confirm(
      `Confirmar eliminación de la receta "${recipe.title}"`,
    );
    if (!confirmed) {
      return;
    }

    deleteRecipe(recipe.recipe_id)
      .then((response) => {
        if (!response.deleted) {
          throw new Error();
        }
        createToast({
          type: "success",
          text: `La receta ${recipe.title} ha sido eliminada.`,
          ttl: 3000,
        });

        setTimeout(() => {
          navigate("/");
        }, 1500);
      })
      .catch(() => {
        createToast({
          type: "danger",
          text: "Ocurrió un problema al eliminar la receta.",
        });
      });
  };

  return (
    <div className="recipe">
      <div className="recipe-header">
        <img
          className="recipe-hero"
          src={recipe.image || "/files/default_recipe.jpg"}
          alt={recipe.title}
        />

        <div className="recipe-info">
          <h1 className="recipe-title">{recipe.title}</h1>
          {recipe.description && (
            <p className="recipe-description">{recipe.description}</p>
          )}
          {recipe.tags?.length > 0 && (
            <div className="recipe-tags tag-list">
              {recipe.tags.map((tag, index) => (
                <span className="tag" key={index}>
                  {tag}
                </span>
              ))}
            </div>
          )}
          <div className="recipe-actions">
            <Link
              to={`/receta/${recipe.recipe_id}/edit`}
              className="btn btn--primary recipe-action"
            >
              <PiPencilSimple />
              <span>Editar</span>
            </Link>
            <button className="btn btn--outline recipe-action" onClick={handleDelete}>
              <PiTrash />
              <span>Eliminar</span>
            </button>
          </div>
        </div>
      </div>

      <div className="recipe-body">
        <div className="recipe-section">
          <h2 className="recipe-section-title">Ingredientes</h2>
          <ul className="recipe-ingredients">
            {recipe.ingredients.map((ingredient, index) => (
              <li className="recipe-ingredient" key={index}>
                <label className="recipe-ingredient-label">
                  <input className="recipe-checkbox" type="checkbox" />
                  <span>{ingredient}</span>
                </label>
              </li>
            ))}
          </ul>
        </div>

        <div className="recipe-section">
          <h2 className="recipe-section-title">Instrucciones</h2>
          <ol className="recipe-instructions">
            {recipe.instructions.map((instruction, index) => (
              <li className="recipe-instruction" key={index}>
                <span className="recipe-step">{index + 1}</span>
                <p>{instruction}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
}

export default Recipe;
